import React from 'react';
import PropTypes from 'prop-types';
import { FaInfoCircle } from 'react-icons/fa';

const ObjectiveLogicNote = ({ items }) => (
  <aside className="tw-rounded-lg tw-border tw-border-slate-300 tw-bg-slate-50 tw-p-3 tw-text-[11px] tw-leading-5 tw-text-slate-600">
    <div className="tw-mb-1.5 tw-flex tw-items-center tw-gap-2 tw-font-semibold tw-text-slate-700">
      <FaInfoCircle className="tw-text-primary-600" size={13} />
      How to read this tab
    </div>
    <ul className="tw-mb-0 tw-list-disc tw-space-y-0.5 tw-pl-5">
      {items.map((item) => <li key={item}>{item}</li>)}
    </ul>
  </aside>
);

ObjectiveLogicNote.propTypes = {
  items: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default ObjectiveLogicNote;
